/**
 * Template: Cart
 * ------------------------------------------------------------------------------
 * Loosely coupled cart page scripts.
 *
 * @namespace cart
 */
import {decodeHTMLEntities} from '~/helpers/utils';
import CartAddOn from '~/components/cart-add-on';
import CartTable from '~/components/cart-table';

import '../../styles/templates/cart.scss'

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-cart="container"]',
  table: '[js-cart-table="container"]',
  panel: '[js-cart="panel"]',
};

/**
 * DOM node selectors.
 */
const nodeSelectors = {
  container: document.querySelector(selectors.container),
  panel: document.querySelector(selectors.panel),
};

document.addEventListener('DOMContentLoaded', () => {
  if (!nodeSelectors.panel) {
    return;
  }

  /**
   * Render cart table.
   */
  CartTable(selectors.table).init();

  if (theme.features.cartAddOn && theme.features.cartAddOnProduct) {
    CartAddOn().init();
  }

  /**
   * Set EventBus event listeners.
   */
  Frame.EventBus.listen('AjaxCart:cartEmpty', () => {
    const strings = {
      title: decodeHTMLEntities(theme.strings.cart.general.title),
      empty: decodeHTMLEntities(theme.strings.cart.general.empty),
      continueBrowsing: decodeHTMLEntities(theme.strings.cart.general.continue_browsing),
    };

    nodeSelectors.container.innerHTML = `
      <div class="container">
        <div class="row">
          <div class="col xs12 m6 offset-m3 text-center">
            <h1 class="template-cart__empty-title">${strings.title}</h1>

            <p class="template-cart__empty-text">
              ${strings.empty}
            </p>

            <a
              class="
                template-cart__empty-button
                button
                button--primary button--dark
                button--large
              "
              href="/collections/all"
            >
              ${strings.continueBrowsing}
            </a>
          </div>
        </div>
      </div>
    `;
  });
});
